var map = {
	"./DiceImages/DiceFive.png": 20777,
	"./DiceImages/DiceFour.png": 65345,
	"./DiceImages/DiceOne.png": 13558,
	"./DiceImages/DiceSix.png": 70580,
	"./DiceImages/DiceThree.png": 443,
	"./DiceImages/DiceTwo.png": 89792,
	"./Fragments/arrow_down.png": 54462,
	"./ImgWithFallback/onErrorImg.png": 53902,
	"./Nodata/bettingBg.png": 86685,
	"./VipLevels/vip1.png": 74051,
	"./VipLevels/vip10.png": 55379,
	"./VipLevels/vip11.png": 6534,
	"./VipLevels/vip12.png": 28927,
	"./VipLevels/vip13.png": 69107,
	"./VipLevels/vip14.png": 48315,
	"./VipLevels/vip15.png": 65632,
	"./VipLevels/vip16.png": 3103,
	"./VipLevels/vip17.png": 71158,
	"./VipLevels/vip18.png": 25222,
	"./VipLevels/vip19.png": 94404,
	"./VipLevels/vip2.png": 68920,
	"./VipLevels/vip20.png": 95509,
	"./VipLevels/vip21.png": 37701,
	"./VipLevels/vip22.png": 25324,
	"./VipLevels/vip23.png": 14037,
	"./VipLevels/vip24.png": 72679,
	"./VipLevels/vip25.png": 59902,
	"./VipLevels/vip26.png": 16729,
	"./VipLevels/vip27.png": 16473,
	"./VipLevels/vip28.png": 13398,
	"./VipLevels/vip29.png": 52225,
	"./VipLevels/vip3.png": 96111,
	"./VipLevels/vip30.png": 74460,
	"./VipLevels/vip31.png": 26950,
	"./VipLevels/vip32.png": 93831,
	"./VipLevels/vip33.png": 76693,
	"./VipLevels/vip34.png": 68781,
	"./VipLevels/vip35.png": 22171,
	"./VipLevels/vip36.png": 47207,
	"./VipLevels/vip37.png": 19647,
	"./VipLevels/vip38.png": 2426,
	"./VipLevels/vip39.png": 56878,
	"./VipLevels/vip4.png": 64164,
	"./VipLevels/vip40.png": 58026,
	"./VipLevels/vip41.png": 41559,
	"./VipLevels/vip42.png": 33962,
	"./VipLevels/vip43.png": 78526,
	"./VipLevels/vip44.png": 21778,
	"./VipLevels/vip45.png": 79727,
	"./VipLevels/vip46.png": 48900,
	"./VipLevels/vip47.png": 77806,
	"./VipLevels/vip48.png": 6484,
	"./VipLevels/vip49.png": 42950,
	"./VipLevels/vip5.png": 13940,
	"./VipLevels/vip50.png": 63878,
	"./VipLevels/vip6.png": 98484,
	"./VipLevels/vip7.png": 90466,
	"./VipLevels/vip8.png": 4689,
	"./VipLevels/vip9.png": 19706,
	"./addscreenmodal1.png": 63415,
	"./addscreenmodal2.png": 61922,
	"./baccarat/D-J.png": 87166,
	"./baccarat/S-10.png": 51474,
	"./baccarat/baccarat_game_settlement.png": 95420,
	"./baccarat/baccarat_game_start_betting.png": 2989,
	"./baccarat/baccarat_game_stop_betting.png": 58961,
	"./baccarat/bet-amount-bg.png": 57800,
	"./baccarat/cards 2.png": 8924,
	"./baccarat/cards/card-back.png": 53877,
	"./baccarat/cards/card-backold.png": 36875,
	"./baccarat/cards/p10_1.png": 98442,
	"./baccarat/cards/p10_2.png": 80554,
	"./baccarat/cards/p10_3.png": 34273,
	"./baccarat/cards/p10_4.png": 6573,
	"./baccarat/cards/p11_1.png": 82001,
	"./baccarat/cards/p11_2.png": 69022,
	"./baccarat/cards/p11_3.png": 77770,
	"./baccarat/cards/p11_4.png": 9685,
	"./baccarat/cards/p12_1.png": 19821,
	"./baccarat/cards/p12_2.png": 82002,
	"./baccarat/cards/p12_3.png": 33509,
	"./baccarat/cards/p12_4.png": 52855,
	"./baccarat/cards/p13_1.png": 74896,
	"./baccarat/cards/p13_2.png": 53322,
	"./baccarat/cards/p13_3.png": 21549,
	"./baccarat/cards/p13_4.png": 75869,
	"./baccarat/cards/p1_1.png": 61266,
	"./baccarat/cards/p1_2.png": 10571,
	"./baccarat/cards/p1_3.png": 32161,
	"./baccarat/cards/p1_4.png": 54564,
	"./baccarat/cards/p2_1.png": 85875,
	"./baccarat/cards/p2_2.png": 81203,
	"./baccarat/cards/p2_3.png": 38780,
	"./baccarat/cards/p2_4.png": 38810,
	"./baccarat/cards/p3_1.png": 51634,
	"./baccarat/cards/p3_2.png": 803,
	"./baccarat/cards/p3_3.png": 54169,
	"./baccarat/cards/p3_4.png": 31753,
	"./baccarat/cards/p4_1.png": 81784,
	"./baccarat/cards/p4_2.png": 78221,
	"./baccarat/cards/p4_3.png": 46730,
	"./baccarat/cards/p4_4.png": 95841,
	"./baccarat/cards/p5_1.png": 89883,
	"./baccarat/cards/p5_2.png": 593,
	"./baccarat/cards/p5_3.png": 5807,
	"./baccarat/cards/p5_4.png": 11137,
	"./baccarat/cards/p6_1.png": 15087,
	"./baccarat/cards/p6_2.png": 35973,
	"./baccarat/cards/p6_3.png": 89277,
	"./baccarat/cards/p6_4.png": 80101,
	"./baccarat/cards/p7_1.png": 49879,
	"./baccarat/cards/p7_2.png": 55062,
	"./baccarat/cards/p7_3.png": 72508,
	"./baccarat/cards/p7_4.png": 2803,
	"./baccarat/cards/p8_1.png": 10422,
	"./baccarat/cards/p8_2.png": 40256,
	"./baccarat/cards/p8_3.png": 23026,
	"./baccarat/cards/p8_4.png": 62076,
	"./baccarat/cards/p9_1.png": 9534,
	"./baccarat/cards/p9_2.png": 821,
	"./baccarat/cards/p9_3.png": 97096,
	"./baccarat/cards/p9_4.png": 25856,
	"./baccarat/chip1.png": 47379,
	"./baccarat/chip10.png": 6892,
	"./baccarat/chip11.png": 34087,
	"./baccarat/chip12.png": 35069,
	"./baccarat/chip13.png": 76990,
	"./baccarat/chip14.png": 95637,
	"./baccarat/chip15.png": 19145,
	"./baccarat/chip2.png": 24682,
	"./baccarat/chip3.png": 67871,
	"./baccarat/chip4.png": 49345,
	"./baccarat/chip5.png": 338,
	"./baccarat/chip6.png": 47939,
	"./baccarat/chip7.png": 56272,
	"./baccarat/chip8.png": 77894,
	"./baccarat/chip9.png": 62810,
	"./baccarat/chips-holder.png": 71918,
	"./baccarat/close-btn.png": 38688,
	"./baccarat/coins.png": 33081,
	"./baccarat/musicCon.png": 91438,
	"./baccarat/noSound.png": 38663,
	"./baccarat/select-chips-btn.png": 14679,
	"./btn-vipactive.png": 8694,
	"./button1.png": 44581,
	"./check.png": 89227,
	"./close.png": 58554,
	"./gray_tick.png": 726,
	"./icons/crown-icon.png": 90163,
	"./icons/promotionIcons/FourIcon.png": 92388,
	"./icons/promotionIcons/OneIcon.png": 91890,
	"./icons/promotionIcons/ThreeIcon.png": 18035,
	"./icons/promotionIcons/TwoIcon.png": 37784,
	"./icons/vipLogo.png": 70016,
	"./loading_bg.png": 9284,
	"./login_bg.png": 98899,
	"./logo_icon.png": 4190,
	"./logo_icon1.png": 71283,
	"./lotteryAssets/lotteryBall.png": 27756,
	"./qrShareBtn.png": 86578,
	"./recharge.png": 78862,
	"./reusable/ImgWithFallback/onErrorImg.png": 62849,
	"./vipImages/GoPayicon.png": 37008,
	"./vipImages/PersonalInfo/01-Smiley.png": 6762,
	"./vipImages/PersonalInfo/02-Person.png": 23505,
	"./vipImages/PersonalInfo/03-PersonBalloon.png": 46616,
	"./vipImages/PersonalInfo/04-IdPerson.png": 12347,
	"./vipImages/PersonalInfo/05-genderIcon.png": 81914,
	"./vipImages/PersonalInfo/06-Calendar.png": 53764,
	"./vipImages/PersonalInfo/07-Wifi.png": 78398,
	"./vipImages/PersonalInfo/08-Penquin.png": 81040,
	"./vipImages/PersonalInfo/09-WeChat.png": 83648,
	"./vipImages/PersonalInfo/10-device.png": 52766,
	"./vipImages/PersonalInfo/11-Message.png": 90222,
	"./vipImages/PersonalInfo/bettingBg.png": 69097,
	"./vipImages/PersonalInfo/blueDevice.png": 63117,
	"./vipImages/VIP1.png": 49429,
	"./vipImages/VIP2.png": 76030,
	"./vipImages/VipLevels/vip1.png": 98874,
	"./vipImages/VipLevels/vip10.png": 37765,
	"./vipImages/VipLevels/vip11.png": 71086,
	"./vipImages/VipLevels/vip12.png": 31681,
	"./vipImages/VipLevels/vip13.png": 51650,
	"./vipImages/VipLevels/vip14.png": 95527,
	"./vipImages/VipLevels/vip15.png": 42739,
	"./vipImages/VipLevels/vip16.png": 22331,
	"./vipImages/VipLevels/vip17.png": 78620,
	"./vipImages/VipLevels/vip18.png": 53297,
	"./vipImages/VipLevels/vip19.png": 36645,
	"./vipImages/VipLevels/vip2.png": 94035,
	"./vipImages/VipLevels/vip20.png": 63479,
	"./vipImages/VipLevels/vip21.png": 55332,
	"./vipImages/VipLevels/vip22.png": 8648,
	"./vipImages/VipLevels/vip23.png": 77800,
	"./vipImages/VipLevels/vip24.png": 84722,
	"./vipImages/VipLevels/vip25.png": 33273,
	"./vipImages/VipLevels/vip26.png": 81377,
	"./vipImages/VipLevels/vip27.png": 95510,
	"./vipImages/VipLevels/vip28.png": 30646,
	"./vipImages/VipLevels/vip29.png": 13814,
	"./vipImages/VipLevels/vip3.png": 14876,
	"./vipImages/VipLevels/vip30.png": 30075,
	"./vipImages/VipLevels/vip31.png": 48322,
	"./vipImages/VipLevels/vip32.png": 37799,
	"./vipImages/VipLevels/vip33.png": 6805,
	"./vipImages/VipLevels/vip34.png": 44982,
	"./vipImages/VipLevels/vip35.png": 82957,
	"./vipImages/VipLevels/vip36.png": 8810,
	"./vipImages/VipLevels/vip37.png": 2742,
	"./vipImages/VipLevels/vip38.png": 70477,
	"./vipImages/VipLevels/vip39.png": 7556,
	"./vipImages/VipLevels/vip4.png": 3785,
	"./vipImages/VipLevels/vip40.png": 76346,
	"./vipImages/VipLevels/vip41.png": 26023,
	"./vipImages/VipLevels/vip42.png": 87682,
	"./vipImages/VipLevels/vip43.png": 75594,
	"./vipImages/VipLevels/vip44.png": 69149,
	"./vipImages/VipLevels/vip45.png": 47900,
	"./vipImages/VipLevels/vip46.png": 66429,
	"./vipImages/VipLevels/vip47.png": 86838,
	"./vipImages/VipLevels/vip48.png": 12226,
	"./vipImages/VipLevels/vip49.png": 88900,
	"./vipImages/VipLevels/vip5.png": 59238,
	"./vipImages/VipLevels/vip50.png": 78371,
	"./vipImages/VipLevels/vip6.png": 8431,
	"./vipImages/VipLevels/vip7.png": 29237,
	"./vipImages/VipLevels/vip8.png": 37425,
	"./vipImages/VipLevels/vip9.png": 29523,
	"./vipImages/advancement_jackpot.png": 48910,
	"./vipImages/arrowvector.png": 5934,
	"./vipImages/gift_icon.png": 69572,
	"./vipImages/plusvector.png": 91009,
	"./vipImages/promotionIcons/FourIcon.png": 79420,
	"./vipImages/promotionIcons/OneIcon.png": 31469,
	"./vipImages/promotionIcons/ThreeIcon.png": 71716,
	"./vipImages/promotionIcons/TwoIcon.png": 92053,
	"./vipImages/vipLogo.png": 92075,
	"./vipPages/blueDevice.png": 11366,
	"./white_tick.png": 37761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86148;